import { FC, memo } from 'react';

import { SunshineModalProps } from 'components/_core/SunshineModal';
import FilePreview from 'components/FilePreview';

import { useReceiptPreviewQuery } from './hooks/useReceiptPreviewQuery';

interface ReceiptPreviewModalProps extends Pick<SunshineModalProps, 'onClose'> {
  receiptId: string;
}

const ReceiptPreviewModal: FC<ReceiptPreviewModalProps> = ({
  onClose,
  receiptId,
}) => {
  const { receipt } = useReceiptPreviewQuery({ receiptId });

  if (!receipt) {
    return null;
  }

  return (
    <FilePreview alt={receipt.sellerName} onClose={onClose} url={receipt.url} />
  );
};

export default memo(ReceiptPreviewModal);
